import React from 'react';

function Checklists() {
  return (
    <div>
      <h1>Checklists Page</h1>
    </div>
  );
}

export default Checklists;
